/**
 * Everyone using the CRM works in India, so dates and times show in India
 * time whatever the computer's own time zone is set to.  A PC left on a US
 * zone otherwise shows every date a day early — a PO dated '2026-09-14' is
 * midnight UTC, which is still 13 Sept there — and every time hours out.
 *
 * Imported once, first thing in main.tsx: Date's toLocaleString,
 * toLocaleDateString and toLocaleTimeString default to India time, and a
 * call that names its own timeZone keeps it.  On a computer already set to
 * India time nothing changes.  getDate(), getHours() and the like still read
 * the computer's zone, so a PC on the wrong zone should be corrected too.
 */
export const OFFICE_TIME_ZONE = 'Asia/Kolkata';

type Format = (this: Date, locales?: string | string[], options?: Intl.DateTimeFormatOptions) => string;

const proto = Date.prototype as unknown as Record<string, unknown>;
const DONE = '__officeTimeZone';

// Once only, so a hot reload in development doesn't wrap the methods twice.
if (!proto[DONE]) {
  Object.defineProperty(proto, DONE, { value: true });
  for (const name of ['toLocaleString', 'toLocaleDateString', 'toLocaleTimeString']) {
    const original = proto[name] as Format;
    proto[name] = function (this: Date, locales?: string | string[], options?: Intl.DateTimeFormatOptions) {
      return original.call(this, locales, options?.timeZone ? options : { ...options, timeZone: OFFICE_TIME_ZONE });
    };
  }
}
